import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import News from "./views/news.vue";
import Desc from "./views/Desc.vue";
import Contact from "./views/Contact.vue";
import Tech from "./views/Tech.vue";
import ProDetail from "./views/product/Pro-detail.vue";
import Product from "./views/product/Product.vue";
import NavBar from "./components/NavBar.vue";
import NewsDetail from "./views/News-detail .vue";
import TechDetail from "./views/Tech-detail.vue";
import Proparams from "./views/product/Proparams.vue";
import Prostandard from "./views/product/Prostandard.vue";
import Promaterial from "./views/product/Promaterial.vue";
import techLicense from "./components/home/techLicense/techLicense.vue";
import licensedetail from "./components/home/techLicense/license-detail.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "NavBar",
      component: NavBar,
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: Home,
        },
        {
          path: "/news",
          name: "news",
          component: News,
        },
        {
          path: "/desc",
          name: "Desc",
          component: Desc,
        },
        {
          path: "/contact",
          name: "Contact",
          component: Contact,
        },
        {
          path: "/tech",
          name: "tech",
          component: Tech,
        },
        {
          path: "/prodetail/:id",
          name: "prodetail",
          component: ProDetail,
        },
        {
          path: "/newsdetail/:id",
          name: "newsdetail",
          component: NewsDetail,
        },
        {
          path: "/licensedetail/:id",
          name: "licensedetail",
          component: licensedetail,
        },
        {
          path: "/techdetail/:id",
          name: "techdetail",
          component: TechDetail,
        },
        {
          path: "/product",
          name: "product",
          component: Product,
        },
        {
          path: "/product/:g",
          name: "product-class",
          component: Product,
          props: true,
        },
        {
          path: "/proparams",
          name: "proparams",
          component: Proparams,
        },
        {
          path: "/prostandard",
          name: "prostandard",
          component: Prostandard,
        },
        {
          path: "/promaterial",
          name: "promaterial",
          component: Promaterial,
        },
        {
          path: "/techlicense",
          name: "techlicense",
          component: techLicense,
        },
        {
          path: "/layout",
          component: () => import("./layouts/TechNews"),
        },
      ],
    },
  ],
});
